import React from 'react'

const AdditionalDataBanner = ({ title, subText, link, linkText }) => {
  return (
    <div className='additional-data-banner'>
      <div className='additional-data-banner-content'>
        <div className='additional-data-banner-content-title'>
          <i className='icon-info additional-data-banner-icon' />
          <span className='semi-bold'>{title}</span>
        </div>
        <div className='additional-data-banner-content-description'>
          {subText}
          {link && (
            <>
              {' '}
              <a
                href={link}
                target='_blank'
                rel='noopener noreferrer'
                className='additional-data-banner-link'
              >
                {linkText}
              </a>
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default AdditionalDataBanner
